import React, { useState } from 'react';

import { SituationSelector } from './components/SituationSelector';
import { SituationOption } from './types';

type DemarchesPermisContainerProps = {
  options: SituationOption[];
};

const DemarchesPermisContainer: React.FC<DemarchesPermisContainerProps> = ({ options }) => {
  const [selectedSituation, setSelectedSituation] = useState<string | null>(null);

  const handleSelectSituation = (value: string): void => {
    setSelectedSituation(value);
  };

  // Tier 1 → tier 2: the hub selector routes to the matching service page, where a narrower
  // selector then routes into the tunnel.
  const handleSubmitSituation = (): void => {
    const option = options.find((situationOption) => situationOption.value === selectedSituation);

    if (!option || !option.target) {
      return;
    }

    window.location.assign(`/demarches-permis/${option.target}#${option.anchor || 'situation'}`);
  };

  return (
    <SituationSelector
      options={options}
      selectedSituation={selectedSituation}
      onSelectSituation={handleSelectSituation}
      onSubmit={handleSubmitSituation}
    />
  );
};

export { DemarchesPermisContainer };
